export default __webpack_public_path__ + "static/media/dialofdestiny004.cf79dfbb.jpeg";